<template>
  <div class="baseetyms">
    <b-container fluid="xxl">
      <b-row>
        <b-col id="select-baseetym">
          <b-form-group
            id="baseetym"
            label="Base Etym:"
            label-for="baseetym"
          >
            <Select2 @select="select($event)" :settings="selectConfig" ref="select2" tabindex="0" />
          </b-form-group>

          <b-form-group
            id="ordering"
            label="Ordering:"
            label-for="ordering"
            v-if="showOrdering"
          >
            <b-form-input
              id="ordering"
              v-model="ordering"
              placeholder="Ordering"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modal-new-base-etym" title="New Base Etym" ok-title="Save" @ok="saveNew" >
      <BaseEtymNewEdit :baseetym="{'form': this.query}" />
    </b-modal>
  </div>
</template>

<script>
import HelpStore from "@/store/helpstore.js";
import Select2 from 'v-select2-component';
import BaseEtymNewEdit from "@/components/Scripta/BaseEtymNewEdit.vue";
import config from '@/config.js';

export default {
  name: "BaseEtymAutocomplete",
  props: ["exclude", "baseEtym", "showOrdering", "headId", "allowNew", "orderingNum", "parentId"],
  data() {
    return {
      query: "",
      timer: null,
      baseEtymObj: this.baseEtym,
      parentIdElem: this.parentId ? this.parentId : "select-baseetym",
      ordering: this.baseEtym ? this.baseEtym.ordering : "",
      index: this.baseEtym ? this.baseEtym._index : null,
      showAddNew: this.allowNew == false ? false : true,
    };
  },
  components: {
    Select2,
    BaseEtymNewEdit,
  },
  methods: {
    select(event){
      if (event.selected && event.id == -2){
        this.$bvModal.show("modal-new-base-etym")
      }
      else {
        this.baseEtymObj = event.selected ? event.baseEtym : null
        this.$emit("select", this.baseEtymObj)
        this.update()
      }
    },
    update(){
      if (this.baseEtymObj){
        this.baseEtymObj["ordering"] = this.ordering;
        this.baseEtymObj["_index"] = this.index;
        HelpStore.item = this.baseEtymObj;
      }
    },
    saveNew(){
      this.$store.dispatch('createBaseetym', HelpStore.item).then((response) => {
        this.baseEtymObj = response.data
        this.$refs.select2.select2.append(
          `<option selected value="${this.baseEtymObj.id}">${this.baseEtymObj.form}</option>`
        ).trigger('change')
        HelpStore.item = this.baseEtymObj
      })
    }
  },
  updated() {
    this.update()
  },
  mounted() {
    if (this.baseEtym){
      this.$refs.select2.select2.append(
        `<option selected value="${this.baseEtym.id}">${this.baseEtym.form}</option>`
      ).trigger('change')
    }
  },
  computed: {
    selectConfig(){
      return {
        placeholder: "Select a base etym",
        // allowClear: this.allowClear == false ? false : true,
        width: '100%',
        dropdownParent: `#${this.parentIdElem}`,
        templateSelection: (val) => {
          return val.form ? val.form : val.text
        },
        ajax: {
          delay: 250,
          url: config.apiUrl + '/baseetyms/autocomplete',
          headers: config.apiHeaders,
          data: (params) => {
            this.query = params.term
            return {
              query: params.term,
              // headId: this.headId,
              exclude: JSON.stringify(this.exclude),
            }
          },
          processResults: (data) => {
            if (data.length == 0 && this.showAddNew && this.query){
              data.push({
                id: -2,
                form: `Create new "${this.query}"`
              })
            }
            return {
              results: data.map(baseEtym => {
                let text = baseEtym.form
                let orderNum = 0
                if (baseEtym.id != -2 && !baseEtym.heads.map(head => head.id).includes(this.headId)) {
                  text = `${text} (not connected to head)`
                  orderNum = 1
                }
                return {
                  id: baseEtym.id,
                  text: text,
                  orderNum: orderNum,
                  form: baseEtym.form,
                  baseEtym: baseEtym
                }
              }).sort((a, b) => a.orderNum - b.orderNum)
            }
          }
        }
      }
    }
  },
};
</script>
